let isLevelProgressBarMounted = false;

export function MarkLevelProgressBarMounted() {
    isLevelProgressBarMounted = true;
}

export function MarkLevelProgressBarUnmounted() {
    isLevelProgressBarMounted = false;
}

export function IsLevelProgressBarMounted() {
    return isLevelProgressBarMounted;
}
